import React from 'react';
import { ShieldCheck, ArrowLeft } from '@phosphor-icons/react';

/** Fixed banner shown on EVERY page while an admin is impersonating a user. */
const GlobalTestModeBanner = () => {
  const backup = typeof window !== 'undefined' ? localStorage.getItem('admin_impersonation_backup') : null;
  const userType = (typeof window !== 'undefined' ? localStorage.getItem('userType') : '') || '';
  if (!backup || userType === 'admin') return null;

  let testUser = null;
  try { testUser = JSON.parse(localStorage.getItem('user') || 'null'); } catch { testUser = null; }

  const endImpersonation = () => {
    try {
      const saved = JSON.parse(backup);
      localStorage.setItem('token', saved.token);
      localStorage.setItem('userType', saved.userType);
      localStorage.setItem('userId', saved.userId);
      localStorage.setItem('user', saved.user);
    } finally {
      localStorage.removeItem('admin_impersonation_backup');
      window.location.href = '/admin';
    }
  };

  return (
    <div className="sticky top-0 z-[90] w-full bg-red-600 text-white border-b-4 border-black" data-testid="global-test-mode-banner">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldCheck size={16} weight="fill" className="shrink-0" />
          <span className="text-[10px] md:text-xs font-black uppercase tracking-widest">Test Mode</span>
          <span className="text-xs md:text-sm font-bold truncate">
            — {testUser?.name || testUser?.email || 'user'} ({userType})
          </span>
        </div>
        <button onClick={endImpersonation}
          className="inline-flex items-center gap-1.5 h-7 px-3 bg-black text-white font-black uppercase text-[10px] tracking-widest border-2 border-white hover:bg-neutral-800 rounded-none transition-colors shrink-0"
          data-testid="global-test-mode-exit">
          <ArrowLeft size={12} weight="bold" />
          Back to Admin
        </button>
      </div>
    </div>
  );
};

export default GlobalTestModeBanner;
